import React, { useState, useEffect, useRef } from 'react';

import './ConnectionModal.scss';

const ConnectionModal = ({ loginAction, closeAction }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [shouldAutoFocus, setShouldAutoFocus] = useState(true);

  const focusInput = useRef(null);

  useEffect(() => {
    if (shouldAutoFocus) {
      focusInput.current.focus();
    }
  }, [shouldAutoFocus]);

  const validate = React.useCallback(
    event => {
      event.preventDefault();
      loginAction({ username, password });
      closeAction();
    },
    [username, password, loginAction, closeAction],
  );

  return (
    <div className="connection-modal">
      <form className="front-modal" onSubmit={validate}>
        <h2>Connection</h2>
        <input
          placeholder="Username"
          className="input-credential"
          value={username}
          onChange={e => setUsername(e.target.value)}
          ref={input => {
            focusInput.current = input;
          }}
        />
        <input
          placeholder="Password"
          type="password"
          className="input-credential"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onFocus={() => setShouldAutoFocus(false)}
        />
        <div className="button-zone">
          <div className="button-left">
            <button
              type="button"
              className="modal-button close"
              onClick={() => closeAction()}
            >
              Cancel
            </button>
          </div>
          <div className="button-right">
            <button type="submit" className="modal-button">
              Log In
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ConnectionModal;
